import React, {useEffect, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import helperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import InitialLoading from "../../components/initial-loading";
import {useParams} from "react-router-dom";
import {AttachmentTypes} from "../../utils/constants";
import Attachment from "../../components/files/attachment";
import {useArticleService} from "../../services/article-service";
import Attachments from "../../components/attachments/attachments";
import ArticleDetailContent from "../../components/articles/article-detail-content";


export default function ArticleDetail () {
  let articleService = useArticleService();

  const params = useParams();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [loaded, setLoaded] = useState(false);
  const [detail, setDetail] = useState(null);
  const [cover, setCover] = useState(null);

  useEffect(()=>{
    let id = params.id;
    if (id){
      loadDetailData(id);
    }
  }, [params.id]);

  const loadDetailData = (id)=>{
    setLoaded(false);

    let promises = [
      articleService.getDetail(id),
    ];

    Promise.all(promises)
      .then(([res= {}])=>{
        let ci = HelperService.getObjByKey(res.attachments, 'attachment_type_id', AttachmentTypes.cover.val);
        setCover(ci ? ci : null);

        setDetail(res);

        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať detail.");
      });
  }

  return (
    <>

      {!loaded && <InitialLoading />}

      {loaded && <ArticleDetailContent article={detail} />}

    </>
  );
}

ArticleDetail.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

ArticleDetail.getSEO = function getSEO() {
  return {
    title: "Detail článku",
  }
}
